module.exports = __webpack_public_path__ + "static/media/pothan_img.c0682983.svg";